import { 
    apiGet,
    apiPost,
    apiPut,
    systemRequestConfig,
    // apiDelete,
    // buildFormData
} from '@api/api.utils'

import { IResponseCommon } from "@api/common.types"

import { 
    IResponseApplications, 
    IResponseApplicationsPromo,
    IResponseApplicationsStatistics,
    IResponseApplicationCheckPhone,
    IResponseApplicationCard,
    IResponseApplicationSave,
    IResponseApplicationTableFilterOptions,
} from "./api.types"

import { 
    IApplicationFotmSendedData, IApplicationsFilter, 
    IApplicationsPromoFilter
} from "./state.types"


/** Маршрут на сервер */
const route = '/applications'


/** Получение заявок */
export const getApplications = (pageNumber: number, search?: string, filter?: IApplicationsFilter, isSystemRequest: boolean = false, signal?: AbortSignal): Promise<IResponseApplications> => {
    const config = {params: {pageNumber, search, filter}, signal}
    return apiGet<IResponseApplications>(`${route}/getApplications`, isSystemRequest ? systemRequestConfig(config) : config)
}

export const trackApplicationViewModeUsage = (viewMode: 'list' | 'table'): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(`${route}/trackApplicationViewModeUsage`, undefined, { viewMode })


export const getApplicationTableFilterOptions = (columnName: string): Promise<IResponseApplicationTableFilterOptions> =>
    apiGet<IResponseApplicationTableFilterOptions>(`${route}/getApplicationTableFilterOptions`, {params: {columnName}})
/** Добавление (Удаление) заявки из чёрного листа */
export const putApplicationBlackList = (applicationID: number, action: string): Promise<IResponseCommon> => 
    apiPut<IResponseCommon>(`${route}/putApplicationBlackList`, {params: {applicationID, action}})

/** Получение статистики по заявкам */
export const getApplicationsStatistics = (): Promise<IResponseApplicationsStatistics> => 
    apiGet<IResponseApplicationsStatistics>(`${route}/getApplicationsStatistics`)

/** Получение промо-заявок */
export const getApplicationsPromo = (pageNumber: number, search?: string, filter?: IApplicationsPromoFilter, signal?: AbortSignal): Promise<IResponseApplicationsPromo> => 
    apiGet<IResponseApplicationsPromo>(`${route}/getApplicationsPromo`, {params: {pageNumber, search, filter}, signal})

/** Добавление (Удаление) заявки из архива */
export const putApplicationPromoArchive = (applicationID: number, action: string): Promise<IResponseCommon> => 
    apiPut<IResponseCommon>(`${route}/putApplicationPromoArchive`, {params: {applicationID, action}})

/** Проверка существования заявки, по номеру телефона клиента */
export const getApplicationCheckPhone = (applicationID: number, clientPhone: string): Promise<IResponseApplicationCheckPhone> => 
    apiGet<IResponseApplicationCheckPhone>(`${route}/getApplicationCheckPhone`, {params: {applicationID, clientPhone}})




/** Получение данных по анкете заявки */
export const getApplicationCard = (applicationID: number): Promise<IResponseApplicationCard> => 
    apiGet<IResponseApplicationCard>(`${route}/getApplicationCard`, {params: {applicationID}})

/** Сохранение данных по анкете заявки */
export const setApplicationCardSave = (applicationID: number, data: IApplicationFotmSendedData): Promise<IResponseApplicationSave> => 
    apiPut<IResponseApplicationSave>(`${route}/setApplicationCardSave`, {params: {applicationID}}, {applicationData: data})

/** Скачивание учебного плана в виде файла */
export const downloadFile = (dataBase: string, filePath: string): Promise<any> => 
    apiGet<any>(`${route}/downloadFile`, { params: { dataBase, filePath }, responseType: 'blob' })




/** Отправка в Telegram канал - Информация для клиента */
export const sendTelegramClientInfo = (applicationID: number): Promise<IResponseCommon> => 
    apiPost<IResponseCommon>(`${route}/sendTelegramClientInfo`, {params: {applicationID}})

/** Отправка в Telegram канал - Учебный план */
export const sendTelegramEducationPlan = (applicationID: number): Promise<IResponseCommon> => 
    apiPost<IResponseCommon>(`${route}/sendTelegramEducationPlan`, {params: {applicationID}})

/** Отправка (ДЕМО + ИНФО) в Telegram канал - Информация для клиента */
export const sendTelegramClientDemoInfo = (applicationID: number): Promise<IResponseCommon> => 
    apiPost<IResponseCommon>(`${route}/sendTelegramClientDemoInfo`, {params: {applicationID}})

/** Отправка (ПОВТОРНЫЙ КЛИЕНТ) в Telegram канал - Информация для клиента */
export const sendTelegramClientRepeat = (applicationID: number): Promise<IResponseCommon> => 
    apiPost<IResponseCommon>(`${route}/sendTelegramClientRepeat`, {params: {applicationID}})

/** Отправка в Telegram канал - Решение клиента обучаться */
export const sendTelegramClientDecisionLearn = (applicationID: number): Promise<IResponseCommon> => 
    apiPost<IResponseCommon>(`${route}/sendTelegramClientDecisionLearn`, {params: {applicationID}})

/** Отправка в Telegram канал - Обучение уже началось */
export const sendTelegramClientTrainingBegun = (applicationID: number): Promise<IResponseCommon> => 
    apiPost<IResponseCommon>(`${route}/sendTelegramClientTrainingBegun`, {params: {applicationID}})

/** Отправка в Telegram канал - Промо */
export const sendTelegramClientNewYear = (applicationID: number): Promise<IResponseCommon> => 
    apiPost<IResponseCommon>(`${route}/sendTelegramClientNewYear`, {params: {applicationID}})

/** Отправка EMAIL - На почту клиенту */
export const sendEmailClientInfo = (applicationID: number, isDemo: number): Promise<IResponseCommon> => 
    apiPost<IResponseCommon>(`${route}/sendEmailClientInfo`, {params: {applicationID, isDemo}})

/** Создание демо-доступа и отправка в Telegram канал - Демо доступ */
export const createDemoAccess = (applicationID: number): Promise<IResponseCommon> => 
    apiPost<IResponseCommon>(`${route}/createDemoAccess`, {params: {applicationID}})

/** Отправка в Telegram канал - Промо (МАКПП) */
export const sendTelegramAppPromo = (applicationID: number): Promise<IResponseCommon> => 
    apiPost<IResponseCommon>(`${route}/sendTelegramAppPromo`, {params: {applicationID}})